import { GetStaticProps } from 'next';

import client from '@utils/apolloClient';
import { getNewsEntryPoints } from '@queries/news.graphql';

import getEntryBoxInfo from '@utils/getEntryBoxInfo';
import getPagination from '@utils/getPagination';

import NewsPage from './archive/[page]';

export default NewsPage;

export const getStaticProps: GetStaticProps = async ({ ...ctx }) => {
  const siteConfig = await import(`~/siteconfig.json`);
  const currentPage: number = Number(ctx.params?.page || 1);

  const pageDescription = `The latest LEGO news. Find out about new LEGO set releases, great deals and new announcements across LEGO City, Star Wars and more.`;

  const {
    data: { NewsItems: news },
  } = await client.query({
    query: getNewsEntryPoints,
    variables: {
      page: currentPage,
      length: siteConfig.pageSize,
    },
  });

  let pages = getPagination(
    'news',
    news.total,
    siteConfig.pageSize,
    currentPage
  );

  return {
    props: {
      currentPage,
      featureFlags: siteConfig.featureFlags,
      description: pageDescription,
      pages,
      posts: news.items.map((item) => getEntryBoxInfo(item, 'News')),
      siteTitle: siteConfig.title,
    },
  };
};
